import { Button } from "primereact/button";

export const ErrorFallbackComponent = () => {
	const handleOnClick = () => {
		window.location.reload();
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				minHeight: "100vh",
				padding: "2rem",
				textAlign: "center",
			}}
		>
			<h1 style={{ color: "#d32f2f", marginBottom: "1rem" }}>
				Ups, da ist etwas schief gelaufen
			</h1>
			<p style={{ marginBottom: "2rem", color: "#666" }}>
				Bitte versuche es später noch einmal.
			</p>
			<Button label="Seite neu laden" onClick={handleOnClick} />
		</div>
	);
};
